export default class CAHA1220RequestModel {
    reservedAmount:string
    receiptStartAge: string
    pensionType:string
    receiptPeriodAc:string
    gender:string
    warrantyPeriod:string
    receiptPeriodLa:string
    receiptPeriodIa:string
    investmentYield:string

}
